export const getPageName = (pathname: string): string => {
  return pathname.replace(/\//g, ":").replace(/^:|:$/g, "");
};